import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import moment from 'moment';
import cx from 'classnames';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import withStyles from 'isomorphic-style-loader/withStyles';

import Link from '../../../Link';
import DatePicker from '../../../Common/DatePicker';
import Loader from '../../../Common/Loader';
import ImageUploadComponent from '../../../Common/ImageUploadComponent';
import CommonImageDisplay from '../../CommonImageDisplay/CommonImageDisplay';
import InputFieldComponent from '../../../Common/InputFieldComponent/InputFieldComponent';
import SelectFieldComponent from '../../../Common/SelectFieldComponent/SelectFieldComponent';

import messages from '../../../../locale/messages';
import validate from './validate';
import onSubmit from './submit';
import { normalizePromoCode } from './normalize';
import { api, promoCodeImageUploadDir } from '../../../../config';

import bt from '../../../../components/commonStyle.css';
import s from './PromoCodeForm.css';


export class PromoCodeForm extends Component {
	static defaultProps = {
		promoId: null,
		promoCurrency: 'USD',
		expiryDate: null
	}

	state = { load: true };

	constructor(props) {
		super(props);
	}

	componentDidUpdate(prevProps) {
		const { locale } = this.props.intl;
		const { locale: prevLocale } = prevProps.intl;

		if (locale !== prevLocale) {
			this.setState({ load: false });
			clearTimeout(this.loadSync);
			this.loadSync = null;
			this.loadSync = setTimeout(() => this.setState({ load: true }), 1);
		}
	}

	success = async (file, fromServer) => {
		const { change } = this.props;
		await change('imageName', fromServer && fromServer.fileName);
	}


	render() {
		const { handleSubmit, promoId, promoType, promoCurrency, expiryDate, loading, submitting, imageName, promoLoader } = this.props;
		const { formatMessage } = this.props.intl;
		const { load } = this.state;
		const isEnableOption = [
			{ value: "true", label: formatMessage(messages.active) },
			{ value: "false", label: formatMessage(messages.inactive) }
		]
		return (
			<div>
				<h1 className='siteAdminPrimaryHeading'>{promoId ? formatMessage(messages.editPromoCode) : formatMessage(messages.addPromoCode)}</h1>
				<div className={cx(s.singleCard, bt.space4)}>
					<div className={cx(s.profileImgSection)}>
						<label className={bt.commonLabelText} >{formatMessage(messages.promoCodeImage)}</label>
						<CommonImageDisplay loader={promoLoader} imageSrc={imageName ? api?.apiEndpoint + promoCodeImageUploadDir + 'medium_' + imageName : null} />
						{
							load && <ImageUploadComponent
								className='commonSiteAdminDropzoneSpace'
								subText={formatMessage(messages.maximumUploadSizeLabel)}
								defaultMessage={formatMessage(messages.chooseFile)}
								componentConfig={{
									iconFiletypes: ['.jpg', '.png', '.svg'],
									multiple: false,
									showFiletypeIcon: false,
									postUrl: api.apiEndpoint + '/uploadPromoCodeImage'
								}}
								success={this.success}
								loaderName={'promoLoader'}
							/>
						}
						{!load && <Loader type={"text"} />}
					</div>
				</div>
				<Form className={s.fullWidth} onSubmit={handleSubmit(onSubmit)}>
					<div className='twoColumnGrid'>
						<Field
							name="title"
							type="text"
							placeholder={formatMessage(messages.title)}
							component={InputFieldComponent}
							label={formatMessage(messages.title)}
							inputClass={bt.formControlInput}
						/>

						<Field
							name="description"
							type="text"
							placeholder={formatMessage(messages.description)}
							component={InputFieldComponent}
							componentClass="textarea"
							label={formatMessage(messages.description)}
							inputClass={bt.formTextArea}
						/>

						<Field
							name="code"
							type="text"
							placeholder={formatMessage(messages.code)}
							component={InputFieldComponent}
							label={formatMessage(messages.code)}
							inputClass={bt.formControlInput}
							normalize={normalizePromoCode}
							maxLength={15}
						/>

						<Field
							name="promoValue"
							type="text"
							placeholder={formatMessage(messages.discount)}
							component={InputFieldComponent}
							label={formatMessage(messages.discount)}
							inputClass={bt.formControlInput}
							isAddon
							suffixLabel={promoType == 2 ? promoCurrency : '%'}
						/>

						<div>
							<label className={bt.commonLabelText} >{formatMessage(messages.expireDate)}</label>
							<DatePicker
								placeholder={formatMessage(messages.expireDate)}
								formName={'PromoCodeForm'}
								fieldName={'expiryDate'}
								initialDate={expiryDate}
								block={true}
								showClearDate={true}
								containerClassName={"adminSingleDatePickerContainer"}
							/>
						</div>
						{
							promoId &&
							<Field
								name="isEnable"
								inputClass={bt.formControlSelect}
								component={SelectFieldComponent}
								label={formatMessage(messages.status)}
								options={isEnableOption}
							/>
						}
					</div>
					<div className='commonButtonContainer'>
						<Link to={"/siteadmin/promo-code/list"} className={bt.btnSecondary} >{formatMessage(messages.goBack)}</Link>
						<Loader
							type={"button"}
							label={promoId ? formatMessage(messages.update) : formatMessage(messages.submitButton)}
							show={loading}
							buttonType={'submit'}
							className={cx(bt.btnPrimary, 'loaderButtonFlex')}
							disabled={submitting || loading}
						/>
					</div>
				</Form>
			</div>
		)
	}
}

PromoCodeForm = reduxForm({
	form: 'PromoCodeForm',
	onSubmit,
	validate
})(PromoCodeForm);

const selector = formValueSelector('PromoCodeForm');
const mapState = state => ({
	promoId: selector(state, 'id'),
	promoType: selector(state, 'type'),
	promoCurrency: selector(state, 'currency'),
	expiryDate: selector(state, 'expiryDate'),
	loading: state?.loader?.AddPromoCode,
	imageName: selector(state, 'imageName'),
	promoLoader: state?.loader?.promoLoader
});

const mapDispatch = {};

export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(PromoCodeForm)));